import { Bubble } from '@ant-design/x';
import { useEffect, useRef, useState } from 'react';
import GrtImage from '@/components/GrtImage';
// import './index.scss';

import { Popup } from 'antd-mobile';
import s from './style/chat.module.scss';
import SkillList from '../../PageComponents/SkillList';
import useChat from '../../../useThirdSkill';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import { Display } from '@/components/Display/Display';
import SessionList from '../../PageComponents/SessionList';
import { getRoles, getUserId, handleStyle } from '@/utils/Page';
import { defaultPageTitle, defaultSkill, defaultPlugins, themeMap, themeStrMap } from '@/utils/Page/constant';
import MobileSender from '../../PageComponents/MobileSender';

import lineImg from '@/assets/images/mobile/line_icon.webp';

import AgentError from '../../PageComponents/AgentError';

import Error from '../../../../components/Mobile/Error';
import TopSkillList from '../../PageComponents/TopSkillList';

import GrtLoading from '@/components/Mobile/GrtLoading/GRTLoading';
import UserInfo from '../../PageComponents/UserInfo';
import AIMarks from '@/components/AiMark';
//TTS
import useTTSHandler from '@/pages/hooks/useTTSHandler';

import { useLeave } from '@/libTTS/useCommon';
import TTSVoiceCallScreen from './roomTTS/TTSVoiceCallScreen/TTSVoiceCallScreen';
import { third_json_handler } from '@/utils/Page/constant';
import ToastUtils from '@/utils/ToastUtils';
import { addChatImg } from '@/utils/Page/constant';
import UserCards from '../../PageComponents/CaseSimulation/UserCards';
import CardButton from '../../PageComponents/CaseSimulation/CardButton';
import AgentInfo from '../../PageComponents/AgentInfo';
import PreQuestion from '../../PageComponents/Prequestion';
import { Hide } from '@/components/Hide';
import { Outlet } from 'react-router-dom';
import { getSearchStr } from '@/utils/Page';
import PersonalWelcome from '../../PageComponents/PersonalRecommend/Welcome';
const searchString = getSearchStr();
const MobileOutsideChats = (props) => {
    const { grtAi, skillStore, simulation, chatStore, sessionStore, preQuestionStore, voiceCallStore } = props.store;
    const listRef = useRef();
    let userId = getUserId();
    const [preAgentInfo, setPreAgentInfo] = useState({});
    const { agentId, sessionId, toolId } = props.params;
    const { isLogin } = grtAi;
    const { currentAgent = {}, agentLoading: detailLoading } = grtAi.state;
    let {
        content,
        setContent,
        startNewMsg,
        onSubmitMsg,
        changeSession,
        checkIsLogin,
        originMsgMap: originMsgMapRef,
        currentSessionMapId: currentSessionMapIdRef,
        formatSessionList,
        linkToSession,
        handlePaste,
        getSessionList,
        isInAnswer,
        checkCanUse,
        authTest,
        changeTool
    } = chatStore;
    let {
        curPlugin,
        setCurPlugin,
        curSkill,
        setCurSkill,
        skillList,
        getGroupSkillList,
        skillPreQuestion,
        isCaseSimulationType,
        isPersonalRecommendType
    } = skillStore;
    let { sessionMap, originSessionList: sessionListRef } = sessionStore;
    const { ttsMessagesRef, ttsContentRef, TTSNewMsg, TTSNewlist, resetVoiceCallStatus } = useTTSHandler({
        store: props.store
    });

    let isCaseSimulation = isCaseSimulationType(curSkill?.ability_id);
    let isPersonalRecommend = isPersonalRecommendType(curSkill?.ability_id);
    const [style, setStyle] = useState({
        webBgUrl: null,
        h5BgUrl: null,
        themeColor: 1
    });

    const [visible, setVisible] = useState(false);
    //tts语言播报控制输入框显示隐藏
    const { isInputVisible, showTTSComponent, showChatInterface, handleBackToChat, handleTTSToggle, hideTTSActions, setHideTTSActions } =
        voiceCallStore;
    const beforeChangeSession = (item) => {
        simulation.setShowCaseCard(false);

        setVisible(false);
        changeSession(item);
    };

    const getHistorySessionList = (time) => {
        let data = {
            user_id: userId,
            agent_id: agentId
        };
        getSessionList(data);
    };
    const getStyle = () => {
        let urlTheme = props.searchParams.get('theme');

        let res = handleStyle(currentAgent?.user_agent_style);
        if (urlTheme) {
            res.themeColor = themeStrMap[urlTheme];
        }

        document.body.setAttribute('data-theme', themeMap[res?.themeColor]);
        setStyle(res);
    };
    const init = () => {
        grtAi.getAgentDetail(agentId);
    };

    useEffect(() => {
        if (agentId) {
            init();
        }
        return () => {
            document.title = defaultPageTitle;
        };
    }, []);

    const handleAngentInfo = () => {
        getStyle();
        getGroupSkillList(currentAgent?.scene_setting, '1', [], isLogin, null, 'mobile');
        document.title = currentAgent?.name || '';
    };
    useEffect(() => {
        handleAngentInfo();
    }, [currentAgent, isLogin]);

    const submitMsg = (msg, isPreQuestion) => {
        if (listRef?.current) {
            let scrollHeight = listRef.current.nativeElement.scrollHeight;
            listRef.current.scrollTo({ offset: scrollHeight, behavior: 'auto' });
        }

        const requestChatParams = {
            character_setting: currentAgent?.character_setting,
            question: msg
        };

        onSubmitMsg(requestChatParams, isPreQuestion);
    };
    //移动端点击选中，再次点击取消选中（选中默认）
    const clickUnApartSkill = (item) => {
        if (curSkill?.ability_id === item?.ability_id) {
            setCurSkill(defaultSkill);
        } else {
            setCurSkill(item);
        }
    };
    useEffect(() => {
        if (sessionId) {
            const search = props.searchParams ? `?${props.searchParams.toString()}` : '';
            props.navigate(`/mobile/o/${agentId}/chat${search}`);
        }
    }, []);

    const getPreQuerstionAgentInfo = () => {
        let agentInfo = currentAgent;
        //显示技能的预设问题和技能描述信息
        if (curSkill?.ability_id != -1) {
            agentInfo = { ...agentInfo, pre_question_json: skillPreQuestion };
        }
        setPreAgentInfo(agentInfo);
        return agentInfo;
    };
    useEffect(() => {
        getPreQuerstionAgentInfo();
    }, [curSkill, currentAgent]);

    // H5 端隐藏多模态技能（third_json.handler === 'multimodal'）
    const filterMobileSkills = (list = []) => {
        return list.filter((item) => item?.third_json?.handler !== third_json_handler.multimodal);
    };

    const getItem = () => {
        let constantMessages = [
            {
                variant: 'borderless',
                role: 'pre',
                content: <AgentInfo />
            }
        ];
        if (!isCaseSimulation) {
            constantMessages.push({
                variant: 'borderless',
                role: 'pre',
                content: (
                    <PreQuestion
                        disabled={!skillStore.skillAvailable}
                        submitMsg={submitMsg}
                        curSkill={curSkill}
                        currentAgent={preAgentInfo}
                    ></PreQuestion>
                )
            });
        }
        if (isPersonalRecommend) {
            constantMessages.push({
                variant: 'borderless',
                role: 'pre',
                content: <PersonalWelcome onSubmit={submitMsg}></PersonalWelcome>
            });
        }
        let messages = [];

        // let agentInfo = getPreQuerstionAgentInfo();

        //容错处理--后端返回的会话id有时会丢失，导致存在undefined:messages会话key
        //url上有sessionId刷新时，sessionMap为空
        if (sessionId) {
            messages = sessionMap?.[sessionId]?.messages || [];
        }

        // 过滤掉隐藏的消息（researcher和reporter类型的消息）
        messages = messages.filter((msg) => !msg.isHidden);

        return [
            ...constantMessages,
            ...messages
            // ...temData
        ];
    };
    const getItemTTS = () => {
        let messages = TTSNewlist;
        // let agentInfo = getPreQuerstionAgentInfo();

        //容错处理--后端返回的会话id有时会丢失，导致存在undefined:messages会话key
        if (!sessionId) {
            messages = [];
        }

        // 过滤掉隐藏的消息（researcher和reporter类型的消息）
        messages = messages.filter((msg) => !msg.isHidden);

        return [
            {
                variant: 'borderless',
                role: 'pre',
                content: <PreQuestion submitMsg={submitMsg} curSkill={curSkill} currentAgent={preAgentInfo}></PreQuestion>
            },

            ...messages
            // ...temData
        ];
    };
    const handleChangeTool = async (tool) => {
        if (tool.id === toolId) {
            return;
        }
        let isLogin = await checkIsLogin();
        if (isLogin) {
            changeTool();
            props.navigate(`/mobile/o/${agentId}/tools/${tool.id}${searchString}`);
        }
    };
    const beforeStartNewMsg = () => {
        if (toolId) {
            return ToastUtils.showToast('该技能无法新增会话');
        }
        startNewMsg();
    };
    // ==================== Render =================
    return (
        <div className={s['mobile-chats-layout']} data-skill-type={skillStore.skillType}>
            {/* 语言对话样式 */}
            <Display show={!showChatInterface}>
                <TTSVoiceCallScreen
                    onBackToChat={handleBackToChat}
                    ttsMessagesRef={ttsMessagesRef}
                    ttsContentRef={ttsContentRef}
                    currentAgent={currentAgent}
                    sessionId={sessionId}
                    getItem={getItemTTS()}
                    listRef={listRef}
                    sessionMap={sessionMap}
                    TTSNewMsg={TTSNewMsg}
                    TTSNewlist={TTSNewlist}
                    resetVoiceCallStatus={resetVoiceCallStatus}
                    originMsgMapRef={originMsgMapRef}
                    hideTTSActions={hideTTSActions}
                    setHideTTSActions={setHideTTSActions}
                />
            </Display>
            <Display show={style?.h5BgUrl}>
                <img className={s['h5-bg']} src={style?.h5BgUrl} alt="" />
            </Display>
            <Popup
                position="right"
                visible={visible}
                onMaskClick={() => {
                    setVisible(false);
                }}
                onClose={() => {
                    setVisible(false);
                }}
                bodyClassName={s['popup-body']}
            >
                <SessionList
                    sessionId={sessionId}
                    setVisible={setVisible}
                    changeSession={beforeChangeSession}
                    visible={visible}
                    getHistorySessionList={getHistorySessionList}
                ></SessionList>
                <UserInfo></UserInfo>
            </Popup>
            <Display show={detailLoading}>
                <GrtLoading></GrtLoading>
            </Display>

            <Display show={!detailLoading && showChatInterface}>
                <Display show={currentAgent.error}>
                    <AgentError err={currentAgent}></AgentError>
                </Display>
                <Display show={!currentAgent.error}>
                    <div className={s['chats-chat']} data-intool={Boolean(toolId)}>
                        <div className={s['header']} data-intool={Boolean(toolId)}>
                            <Hide show={toolId || curSkill?.ability_id}>
                                <div className={s['top-skill']}>
                                    <TopSkillList
                                        toolList={currentAgent?.scene_tool}
                                        curToolId={toolId}
                                        changeTool={handleChangeTool}
                                        isNewChat={!sessionId}
                                        skillList={skillList.apartList}
                                    ></TopSkillList>
                                </div>
                            </Hide>

                            <div className={s['add-new-chat']} onClick={beforeStartNewMsg}>
                                <GrtImage src={addChatImg[style.themeColor]}></GrtImage>
                            </div>

                            <div className={s['action']}>
                                <span
                                    onClick={() => {
                                        setVisible(true);
                                    }}
                                >
                                    <GrtImage src={lineImg}></GrtImage>
                                </span>
                            </div>
                        </div>
                        <Hide show={toolId}>
                            <Outlet></Outlet>
                        </Hide>
                        <Hide show={!toolId}>
                            <Hide show={!isCaseSimulation || (sessionId && !simulation.showCaseCard)}>
                                {/* 🌟 消息列表 */}
                                <Bubble.List
                                    autoScroll={sessionId ? true : false}
                                    ref={listRef}
                                    items={getItem()}
                                    roles={getRoles(sessionMap?.[sessionId]?.loading)}
                                    className={`${s['chats-messages']}`}
                                />
                            </Hide>
                            <Display show={isCaseSimulation}>
                                <Display show={true}>
                                    <UserCards
                                        simulation={simulation}
                                        setShowCaseCard={simulation.setShowCaseCard}
                                        onSubmitMsg={onSubmitMsg}
                                        curSkill={curSkill}
                                        sessionId={sessionId}
                                        expand={simulation.showCaseCard}
                                    />
                                </Display>
                                {/* <Display show={sessionId}>
                                    <CardButton setShowCaseCard={simulation.setShowCaseCard} expand={simulation.showCaseCard} />
                                </Display> */}
                            </Display>
                            <Display show={!isCaseSimulation}>
                                <Display show={curSkill?.ability_id}>
                                    {/* 🌟 提示词 */}
                                    <Display
                                        show={
                                            curSkill &&
                                            (!curSkill?.apart || curSkill?.ability_id == -1) &&
                                            !(curSkill?.ability_id == -1 && curSkill?.left_side === 0)
                                        }
                                    >
                                        <SkillList
                                            themeColor={style.themeColor}
                                            setCurPlugin={setCurPlugin}
                                            curSkill={curSkill}
                                            setCurSkill={clickUnApartSkill}
                                            skillList={filterMobileSkills(skillList.unApartList)}
                                        ></SkillList>
                                    </Display>
                                </Display>
                            </Display>
                        </Hide>
                    </div>
                    <Display show={!toolId && curSkill?.ability_id && !isCaseSimulation}>
                        {/* 🌟 输入框 */}
                        <div className={s['input-wrap']}>
                            <Display show={!skillStore.skillAvailable}>
                                <div
                                    onClick={() => {
                                        ToastUtils.showToast('该技能暂不可用');
                                    }}
                                    className={s['unavailable-box']}
                                ></div>
                            </Display>
                            <MobileSender
                                handlePaste={handlePaste}
                                authTest={authTest}
                                curSkill={curSkill}
                                themeColor={style?.themeColor}
                                placeholder={curSkill?.default_prompt}
                                value={content}
                                plugins={curSkill?.ability_id == -1 ? defaultPlugins : curSkill?.plugin_json || []}
                                setCurPlugin={setCurPlugin}
                                agentId={agentId}
                                skillId={curSkill?.ability_id}
                                curPlugin={curPlugin}
                                onSubmit={submitMsg}
                                onTTSToggle={handleTTSToggle}
                                onChange={setContent}
                                linkToSession={linkToSession}
                                sessionListRef={sessionListRef}
                                formatSessionList={formatSessionList}
                                loading={sessionMap?.[sessionId]?.loading || sessionMap?.[sessionId]?.answering}
                                sessionMap={sessionMap}
                                showTTSComponent={showTTSComponent}
                                currentSessionMapIdRef={currentSessionMapIdRef}
                                showChatInterface={showChatInterface}
                                isInputVisible={isInputVisible}
                                checkIsLogin={checkIsLogin}
                                checkCanUse={checkCanUse}
                                isInAnswerRef={isInAnswer}
                                hideTTSActions={hideTTSActions}
                                setHideTTSActions={setHideTTSActions}
                            ></MobileSender>
                            <AIMarks
                                index={0}
                                size="14"
                                style={{ color: 'rgba(0, 0, 0, 0.45)', textAlign: 'center', marginTop: 12, height: 'auto', lineHeight: 'initial' }}
                            />
                        </div>
                    </Display>
                </Display>
            </Display>
        </div>
    );
};

export default withRouter(inject('store')(observer(MobileOutsideChats)));
